<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">Firmas por firmar</h1>
    </div>

    <wz-alert v-if="loaded && !inbox.length" variant="warning" class="mb-3">
      <strong>Tu usuario no está vinculado a ningún firmante.</strong> Pásale el ID de abajo a un administrador con el permiso
      de firmas: tiene que vincularlo en Empresas, pestaña Firmantes. Nadie puede vincularse a sí mismo.
    </wz-alert>

    <wz-card title="Tu ID de usuario">
      <p v-if="keycloakUserId" class="mb-1"><code style="user-select: all;">{{ keycloakUserId }}</code></p>
      <p v-else class="mb-1 text-muted">No se pudo leer tu ID. Cierra sesión y vuelve a entrar.</p>
      <p class="text-muted text-sm mb-0">Con este dato un administrador vincula tu usuario a un firmante de la empresa.</p>
    </wz-card>

    <signer-inbox-card v-for="entry in inbox" :key="entry.signerId" :entry="entry" class="mt-3" @reload="load" />
  </div>
</template>

<script>
import { Alert } from '@wizepe/wizeui'
import { mapGetters } from 'vuex'
import { SignatureService } from '@/core/services'
import SignerInboxCard from '../Components/SignerInboxCard.vue'

export default {
  name: 'SignatureInbox',
  components: { SignerInboxCard },
  data() {
    return {
      inbox: [],
      loaded: false,
    }
  },
  computed: {
    ...mapGetters({ keycloakUserId: 'auth/getKeycloakUserId' }),
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      try {
        await this.$store.dispatch('app/loading', true)
        this.inbox = (await SignatureService.inbox()).payload || []
        this.loaded = true
      } catch (e) {
        Alert.error(e.errors ? e.errors.message : 'Error al cargar la bandeja')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
  },
}
</script>
